import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router'
import Details from '../components/Details'

@withRouter
@inject('program') @observer
export default class ProgramDetailsContainer extends Component {

  static propTypes = {
    params: PropTypes.shape({
      id: PropTypes.string.isRequired
    }),
    program: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
  }

  componentDidMount() {
    if (this.props.params.id) {
      this.props.program.load(this.props.params.id)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.params.id !== this.props.params.id) {
      this.props.program.load(nextProps.params.id)
    }
  }

  render() {

    const { program, params } = this.props

    if (program.loading) {
      return <div>Program wird geladen</div>
    }

    const entry = program.getById(params.id)

    if (!entry) {
      return <div>Programm nicht gefunden!</div>
    }

    return (
      <Details
        params={this.props.params}
        program={entry}
        router={this.props.router}
      />
    )
  }

}



// WEBPACK FOOTER //
// ./src/frontend/program/containers/DetailsContainer.js